export function axCoerceBoolean(x) {
    return !!x;
}
